export const degreesToRadians = (rotationDeg) => rotationDeg * (Math.PI / 180)

export const REST_DESIGNER_POLAR_ANGLE = 'REST_DESIGNER_POLAR_ANGLE'